export default __webpack_public_path__ + "static/media/twoatoms.4263c3dc.svg";